// @ts-check

import React from "react";
import "../styles/DonorCard.css";
import DonorCard from "./DonorCard";
import LegacyDonorCard from "./LegacyDonorCard";

/**
 * @typedef {import('./coreTypes').ResultAtom} ResultAtom
 * @typedef {import('./coreTypes').JSResultAtom} JSResultAtom
 * @typedef {import('./coreTypes').QuerySpec} QuerySpec
 * @typedef {import('./coreTypes').JSX} JSX
 */


/**
 * @param {{ donors: JSResultAtom[][], currentIndex: number, totalPages: number, isTentative: boolean }} props 
 * @returns {JSX}
 * 
 * donors is columns of ResultAtoms
 * currentIndex is an integer in [0, totalPages)
 * totalPages is an integer > 0
 * 
 */
function DonorCardLayout(props) {
	
	if (props.donors.length === 1 && props.donors[0].length === 1) {
		var card = getCardForDonor(props.donors[0][0], '0');
		return (
			<div className="top-container--single-card">
				<div className="donor-card-container">
					{card}
				</div>
			</div>
			);
	}
	else {
		// display the cards in columns
		
		const numOfStacks = props.donors.length;
		/**
		 * @type {JSX.Element[][]}
		 */
		const stacks = [];
		
		for (let col = 0; col < numOfStacks; col++) {
			stacks.push([]);
			for (let row = 0; row < props.donors[col].length; row++) {
				const key = col + '_' + row;
				const newCard = getCardForDonor(props.donors[col][row], key);
				if (newCard !== null) stacks[col].push(newCard);
			}
		}
		
		const containers = 
			stacks.map(s => (<div className="donor-card-container">{s}</div>));
		
		return (
			<div className="top-container">
				{containers}
				<p className="donor-page-of-page">Page {props.currentIndex+1} of {props.totalPages}{props.isTentative ? "..." : ""}</p>
			</div>
			);
	}
}


/**
 * @param {JSResultAtom} d 
 * @param {string} k 
 * @returns {JSX?}
 */
function getCardForDonor(d, k) {
	switch (d[0]) {
		case 'donor': return (<DonorCard donor={d[1]} key={k} />);
		case 'donor_legacy': return (<LegacyDonorCard donor={d[1]} key={k} />);
		default: return null;
	}
}

export default DonorCardLayout;
